const BASE_URL = "https://ratecleaner.com"
const ORGANIZATION_ID = `${BASE_URL}/#organization`
const WEBSITE_ID = `${BASE_URL}/#website`
const SEO_MANAGED_ATTRIBUTE = "data-seo-managed"
const SEO_MANAGED_VALUE = "ratecleaner"
const DEFAULT_TITLE = "Rate Cleaner | Improving Rate Descriptions in Hospitality"
const DEFAULT_DESCRIPTION =
  "Rate Cleaner helps to optimize rate descriptions, leading to increased sales, reduced costs, and efficient rate management."
const DEFAULT_IMAGE = `${BASE_URL}/Miniatura1200x627.png`

const PAGE_METADATA = {
  "/": {
    title: DEFAULT_TITLE,
    description: DEFAULT_DESCRIPTION,
    sitemap: true,
  },
  "/hotels": {
    title: "Rate Cleaner for Hotels | Improving Rate Descriptions in Hospitality",
    description: DEFAULT_DESCRIPTION,
    sitemap: true,
  },
  "/travel-agencies": {
    title:
      "Rate Cleaner for Travel Agencies | Improving Rate Descriptions in Hospitality",
    description: DEFAULT_DESCRIPTION,
    sitemap: true,
  },
  "/privacy-policy": {
    title: "Privacy Policy | Rate Cleaner",
    description: "Read the Privacy Policy for Rate Cleaner.",
    robots: "noindex,follow",
    sitemap: false,
  },
  "/cookies-policy": {
    title: "Cookies Policy | Rate Cleaner",
    description: "Read the Cookies Policy for Rate Cleaner.",
    robots: "noindex,follow",
    sitemap: false,
  },
  "/terms": {
    title: "Terms | Rate Cleaner",
    description: "Read the Terms for Rate Cleaner.",
    robots: "noindex,follow",
    sitemap: false,
  },
}

const normalizePathname = (pathname = "/") => {
  const [cleanPath] = `${pathname}`.split(/[?#]/)
  const normalizedPath = cleanPath || "/"

  if (normalizedPath !== "/" && normalizedPath.endsWith("/")) {
    return normalizedPath.slice(0, -1)
  }

  return normalizedPath
}

const buildAbsoluteUrl = pathname => {
  const normalizedPath = normalizePathname(pathname)

  if (normalizedPath === "/") {
    return BASE_URL
  }

  return `${BASE_URL}${normalizedPath}`
}

const getPageMetadata = (pathname = "/") => {
  const normalizedPath = normalizePathname(pathname)
  const pageMetadata = PAGE_METADATA[normalizedPath] || {}

  return {
    title: pageMetadata.title || DEFAULT_TITLE,
    description: pageMetadata.description || DEFAULT_DESCRIPTION,
    image: pageMetadata.image || DEFAULT_IMAGE,
    url: buildAbsoluteUrl(normalizedPath),
    path: normalizedPath,
    type: pageMetadata.type || "website",
    robots: pageMetadata.robots || "index,follow",
    sitemap: pageMetadata.sitemap !== false,
  }
}

const getSitemapPaths = () =>
  Object.entries(PAGE_METADATA)
    .filter(([, metadata]) => metadata.sitemap !== false)
    .map(([pathname]) => pathname)

const getStructuredData = (pathname = "/") => {
  const metadata = getPageMetadata(pathname)

  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": ORGANIZATION_ID,
        name: "Rate Cleaner",
        url: BASE_URL,
        logo: DEFAULT_IMAGE,
      },
      {
        "@type": "WebSite",
        "@id": WEBSITE_ID,
        url: BASE_URL,
        name: "Rate Cleaner",
        inLanguage: "en",
        description: DEFAULT_DESCRIPTION,
        publisher: {
          "@id": ORGANIZATION_ID,
        },
      },
      {
        "@type": "WebPage",
        url: metadata.url,
        name: metadata.title,
        description: metadata.description,
        inLanguage: "en",
        isPartOf: {
          "@id": WEBSITE_ID,
        },
      },
    ],
  }
}

module.exports = {
  BASE_URL,
  DEFAULT_DESCRIPTION,
  DEFAULT_IMAGE,
  DEFAULT_TITLE,
  SEO_MANAGED_ATTRIBUTE,
  SEO_MANAGED_VALUE,
  getPageMetadata,
  getSitemapPaths,
  getStructuredData,
  normalizePathname,
}
